import classes from "./Section2.module.css";

export default function Section2() {
  return (
    <div className={classes.section2Wrapper}>
      <div className={classes.section2Container}>
        <div className={classes.section2image}>
          <img src="/img/home-img/home-about-img.jpg" alt="about-us" />
        </div>
        <div className={classes.section2Text}>
          <h2>
            About <span>TechMatter</span>
          </h2>
          <p>
            Discover top-quality IT hardware solutions at unbeatable prices.
            From high-performance servers and custom-built PCs to networking
            devices and essential components — TechMatter is your trusted
            partner for business-grade technology across the UK and Europe. We
            aim to empower businesses, IT professionals, and enthusiasts with
            reliable products and unmatched service.
          </p>
          <p>
            At TechMatter, we are not just a retailer — we are your trusted
            technology partner, committed to helping you achieve operational
            efficiency, innovation, and growth in an increasingly digital world.
          </p>
          <ul>
            <li>
              Wide range of IT hardware: servers, PCs, routers, switches, and
              more.
            </li>
            <li>Custom-built PC solutions tailored to your needs.</li>
            <li>Competitive pricing without compromising quality.</li>
            <li>Fast and secure delivery across the UK and Europe.</li>
            <li>Expert customer support to assist with technical queries.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
